import { stronaPrzedmiotuActionTypes } from '.';

type tabId = DynamicTabComponent['id'];

export const init = (tabId: tabId) => ({
  type: stronaPrzedmiotuActionTypes.INIT,
  payload: { tabId },
} as const);
export const getFiltersList = (tabId: tabId) => ({
  type: stronaPrzedmiotuActionTypes.FILTERS_GET_CONFIG_START,
  payload: { tabId },
} as const);
export const getLeftPanelData = (tabId: tabId) => ({
  type: stronaPrzedmiotuActionTypes.GET_LEFT_PANEL_DATA_START,
  payload: { tabId },
} as const);
export const getData = (tabId: tabId) => ({
  type: stronaPrzedmiotuActionTypes.GET_DATA_START,
  payload: { tabId },
} as const);
export const syncDataWithCache = (tabId: tabId) => ({
  type: stronaPrzedmiotuActionTypes.SYNC_DATA_WITH_CACHE_START,
  payload: { tabId },
} as const);
export const getColumnsConfig = (tabId: tabId) => ({
  type: stronaPrzedmiotuActionTypes.COLUMNS_GET_CONFIG_START,
  payload: { tabId },
} as const);
export const saveColumnsUserSetup = (tabId: tabId, selectedColumns: SelectedColumns) => ({
  type: stronaPrzedmiotuActionTypes.COLUMNS_SAVE_USER_SETUP_START,
  payload: { tabId, selectedColumns },
} as const);
export const refreshFilterValues = (tabId: tabId) => ({
  type: stronaPrzedmiotuActionTypes.FILTERS_REFRESH_VALUES_START,
  payload: { tabId },
} as const);
export const getRecordDetails = (tabId: tabId, recordId: string | number, refresh: boolean) => ({
  type: stronaPrzedmiotuActionTypes.RECORD_GET_DETAILS_START,
  payload: { tabId, recordId, refresh },
} as const);
export const refreshData = (tabId: tabId) => ({
  type: stronaPrzedmiotuActionTypes.REFRESH_DATA_START,
  payload: { tabId },
} as const);
export const refreshSelectedData = (tabId: tabId, recordsToRefresh: ViewDataSet['selected']) => ({
  type: stronaPrzedmiotuActionTypes.REFRESH_SELECTED_DATA_START,
  payload: { tabId, recordsToRefresh },
} as const);
export const getDataCsv = (tabId: tabId) => ({
  type: stronaPrzedmiotuActionTypes.DATA_GET_CSV_START,
  payload: { tabId },
} as const);
export const copyFinalMarks = (studentsData: AppConfig.StudentDataInCopyFinalMarkModal[]) => ({
  type: stronaPrzedmiotuActionTypes.STUDENTS_COPY_FINAL_MARKS_START,
  payload: { studentsData },
} as const);
export const copyFinalMarksSuccess = (tabId: tabId) => ({
  type: stronaPrzedmiotuActionTypes.STUDENTS_COPY_FINAL_MARKS_SUCCESS,
  payload: { tabId },
} as const);

export const getDataStudentListWithMarks = (tabId: tabId) => ({
  type: stronaPrzedmiotuActionTypes.GET_DATA_STUDENT_LIST_WITH_MARKS_START,
  payload: { tabId },
} as const);
export const getDataStudentListWithMarksSuccess = (tabId: tabId, data: GetDataSuccessPayload) => ({
  type: stronaPrzedmiotuActionTypes.GET_DATA_STUDENT_LIST_WITH_MARKS_SUCCESS,
  payload: { tabId, data },
} as const);
export const getDataStudentListWithMarksFail = (tabId: tabId) => ({
  type: stronaPrzedmiotuActionTypes.GET_DATA_STUDENT_LIST_WITH_MARKS_FAIL,
  payload: { tabId },
} as const);
export const getDataStudentListWithMarksCancel = (tabId: tabId) => ({
  type: stronaPrzedmiotuActionTypes.GET_DATA_STUDENT_LIST_WITH_MARKS_CANCEL,
  payload: { tabId },
} as const);